import { createFileRoute } from "@tanstack/react-router";
import { sanitizeRedirect } from "@/lib/auth-redirect";
import { REVEAL_SEARCH_PARAM, REVEAL_SEARCH_VALUE } from "@/lib/login-form-reveal";

// Non-lazy half of /login: the search schema has to be declared outside the
// lazy chunk so the router can parse ?redirect= before the form loads. The
// component lives in login.lazy.tsx.

type LoginSearch = {
  redirect?: string;
  // `?login=local` is one of the two escape hatches that bring back the
  // username/password form where it is hidden — see lib/login-form-reveal.ts.
  // Declared here because the router drops search keys the schema omits.
  [REVEAL_SEARCH_PARAM]?: typeof REVEAL_SEARCH_VALUE;
};

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearch => {
    const parsed: LoginSearch = {};
    const redirect = sanitizeRedirect(search.redirect);
    if (redirect) parsed.redirect = redirect;
    if (search[REVEAL_SEARCH_PARAM] === REVEAL_SEARCH_VALUE) {
      parsed[REVEAL_SEARCH_PARAM] = REVEAL_SEARCH_VALUE;
    }
    return parsed;
  },
});
